import { render, staticRenderFns } from "./ReportNew.vue?vue&type=template&id=01213293"
import script from "./ReportNew.vue?vue&type=script&lang=js"
export * from "./ReportNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports